import comp from "./InlineEditor";
export default comp;
